import React, { useState } from "react";

export default function QuoteForm() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    alert("Thank you! Our team will contact you soon.");
    setFormData({ name: "", phone: "", message: "" });
  };

  return (
    <section className="bg-white p-8 shadow-md rounded-xl max-w-lg mx-auto mt-10 border border-gray-200">
      <h2 className="text-2xl font-bold mb-4 text-center">
        Get an Instant Quote
      </h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          type="text"
          name="name"
          placeholder="Your Name"
          value={formData.name}
          onChange={handleChange}
          required
          className="w-full border p-3 rounded-lg"
        />
        <input
          type="tel"
          name="phone"
          placeholder="Phone Number"
          value={formData.phone}
          onChange={handleChange}
          required
          className="w-full border p-3 rounded-lg"
        />
        <textarea
          name="message"
          placeholder="Your Message (e.g. Need 5000 bricks in Giridih)"
          value={formData.message}
          onChange={handleChange}
          rows="3"
          className="w-full border p-3 rounded-lg"
        />
         {/* ✅ RCS Opt-in Checkbox */}
        <label className="flex items-start gap-2 text-sm text-gray-700">
          <input
            type="checkbox"
            name="consent"
            checked={formData.consent}
            onChange={handleChange}
            className="mt-1"
            required
          />
          <span>
            I agree to receive messages for communication via RCS / WhatsApp / SMS.
          </span>
        </label>
        <button
          type="submit"
          className="bg-blue-600 text-white font-semibold w-full p-3 rounded-lg hover:bg-blue-700"
        >
          Send Request
        </button>
        
      </form>
    </section>
  );
}
